import { render, staticRenderFns } from "./uploadedTable.vue?vue&type=template&id=95e9381a&scoped=true&"
import script from "./uploadedTable.vue?vue&type=script&lang=js&"
export * from "./uploadedTable.vue?vue&type=script&lang=js&"
import style0 from "./uploadedTable.vue?vue&type=style&index=0&id=95e9381a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e9381a",
  null
  
)

export default component.exports